import { get, writable } from 'svelte/store'

import { goto } from '$app/navigation'
import { page } from '$app/stores'

const nav_Main_store  = writable('')
const nav_Child_store = writable('')

export { nav_Main_store  as navMainUrl }
export { nav_Child_store as navChildUrl }

//--- NAVIGATION: MAIN    ---
export function restorePreviousNavLocation()
{
	const navChildUrl = get(nav_Child_store)
	if (navChildUrl != '')
		restorePreviousNavChildLocation()
	else
		restorePreviousNavMainLocation()

}


export function gotoNavMainLocation(location: string)
{
	setNavMainLocation(location)
	goto(location)
}

export function saveCurrentNavMainLocation()
{
	const navUrl = get(page).url.pathname
	setNavMainLocation(navUrl)
} 

export function setNavMainLocation(navUrl: string)
{
	nav_Main_store.set(navUrl)
} 
export function resetNavMainLocation()
{
	nav_Main_store.set('')
} 

export function restorePreviousNavMainLocation()
{
	const navUrl = get(nav_Main_store)
	goto(navUrl)
	//resetNavMainLocation()
}
//---------------------------



//--- NAVIGATION: CHILD   ---
export function gotoNavChildLocation(location: string)
{
	setNavChildLocation(location)
	goto(location)
}

export function saveCurrentNavChildLocation()
{
	const navUrl = get(page).url.pathname
	setNavChildLocation(navUrl)
} 

export function setNavChildLocation(navUrl: string)
{
	nav_Child_store.set(navUrl)
} 
export function resetNavChildLocation()
{
	nav_Child_store.set('')
} 

export function restorePreviousNavChildLocation()
{
	const navUrl = get(nav_Child_store)
	goto(navUrl)
	resetNavChildLocation()
}
//---------------------------
